import { CertificateRequestStatus } from "@tfg/db/browser"
import { StatusBadge } from "@tfg/ui"
import type { ReactNode } from "react"

import { useGetCertificateRequestStatus } from "~/pages/Brand/Certificates/hooks/useCertificateRequestStatusDetails"

type Props = {
  certificateRequestStatus: CertificateRequestStatus
  userType: "brand" | "supplier"
  rightSection?: ReactNode
  displayMode?: "default" | "lifecycle"
}

export function CertificateRequestStatusBadge({
  certificateRequestStatus,
  userType,
  rightSection,
  displayMode = "default",
}: Props) {
  const certificateRequestStatusDetails = useGetCertificateRequestStatus(
    certificateRequestStatus,
    userType,
    displayMode
  )
  if (!certificateRequestStatusDetails) return null
  return (
    <StatusBadge
      size="sm"
      text={certificateRequestStatusDetails.translation}
      variant={certificateRequestStatusDetails.variant}
      icon={null}
      rightSection={rightSection}
    />
  )
}
